__turbopack_context__.v({
  "className": "open_sans_fa237f99-module__5HFnjW__className",
});
